const donarsData = [
    {
      name: "John Doe",
      photo: "./galleryPhoto/1.webp",
      linkedin: "https://linkedin.com/in/johndoe",
      gmail: "johndoe@gmail.com",
      instagram: "https://instagram.com/johndoe",
    },
    {
      name: "Jane Smith",
      photo: "./galleryPhoto/2.webp",
      linkedin: "https://linkedin.com/in/janesmith",
      gmail: "janesmith@gmail.com",
      instagram: "https://instagram.com/janesmith",
    },
    {
        name: "Jane Smith",
        photo: "./galleryPhoto/2.webp",
        linkedin: "https://linkedin.com/in/janesmith",
        gmail: "janesmith@gmail.com",
        instagram: "https://instagram.com/janesmith",
      },{
        name: "Jane Smith",
        photo: "./galleryPhoto/2.webp",
        linkedin: "https://linkedin.com/in/janesmith",
        gmail: "janesmith@gmail.com",
        instagram: "https://instagram.com/janesmith",
      },{
        name: "Jane Smith",
        photo: "./galleryPhoto/2.webp",
        linkedin: "https://linkedin.com/in/janesmith",
        gmail: "janesmith@gmail.com",
        instagram: "https://instagram.com/janesmith",
      },{
        name: "Jane Smith",
        photo: "./galleryPhoto/2.webp",
        linkedin: "https://linkedin.com/in/janesmith",
        gmail: "janesmith@gmail.com",
        instagram: "https://instagram.com/janesmith",
      },{
        name: "Jane Smith",
        photo: "./galleryPhoto/2.webp",
        linkedin: "https://linkedin.com/in/janesmith",
        gmail: "janesmith@gmail.com",
        instagram: "https://instagram.com/janesmith",
      },
  ];
  
  export default donarsData;
  